"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-computer.tsx
var Computer = function Computer(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M16.6667 15C17.5833 15 18.325 14.25 18.325 13.3334L18.3333 5.00004C18.3333 4.08337 17.5833 3.33337 16.6667 3.33337H3.33333C2.41667 3.33337 1.66667 4.08337 1.66667 5.00004V13.3334C1.66667 14.25 2.41667 15 3.33333 15H0V16.6667H20V15H16.6667ZM3.33333 5.00004H16.6667V13.3334H3.33333V5.00004Z",
    fill: "currentColor"
  }));
};

var _default = Computer;
exports.default = _default;